<template>
  <a href="/new-brand-cloud" data-ajax-off="true">
    <aw-icon icon="partner" class="w-5 h-5 "></aw-icon>
    {{ $t('Create BrandCloud') }}
  </a>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped></style>
